import Config from '@/config'
import { removeUserActiveCompanyId } from '@/store/company'

import router from '../router'
import store from '../store'

export function interceptor(request, next) {
  const { api, apiv2, apiApp, apiReporting } = Config
  const jwt = localStorage.getItem('jwt')
  // The surveys API is anonymous and its authorizer denies any Authorization header it did not
  // issue. Must run before the routing below rewrites request.url.
  const isGuestSurveysApi = typeof request.url === 'string' && request.url.startsWith('surveys/')

  if (typeof request.url == 'object') {
    if (!apiv2[request.url.apiName]) {
      throw `Missing apiName - ${request.url.apiName} in config.`
    }

    if (request.url.action) {
      request.headers.set('ovation-action', request.url.action)
    }

    request.headers.set('client-identifier', store.getters['user/onlineUser']._id)

    request.url = `${apiv2[request.url.apiName]}/${request.url.resource}`
  } else if (
    request.url.startsWith('app-') ||
    request.url.startsWith('surveys/') ||
    request.url.startsWith('gift-cards/') ||
    request.url.startsWith('spoton/')
  ) {
    request.url = `${apiApp}/${request.url}`
  } else if (request.url.startsWith('api')) {
    request.url = `${apiReporting}/${request.url}`
  } else {
    request.url = `${api}/${request.url}`
  }

  if (jwt && !isGuestSurveysApi) {
    request.headers.set('Authorization', jwt)
  }
}
